module.exports = __webpack_public_path__ + "static/media/plus-branco.b8847ec6.webp";